"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODE_PATHS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODE_PATHS = (0, gql_1.gql)(`
  query productTreeNodePaths(
    $productTreeId: ID!,
    $filter: ProductTreeNodeFilter,
    $first: Int,
    $firstAncestors: Int,
    $sort: [ProductTreeNodeRelativeOrderBy!],
  ) {
    productTreeNodes(ancestralProductTreeId: $productTreeId, filter: $filter, first: $first) {
      edges {
        node {
          id
          title
          ancestors(first: $firstAncestors, sort: $sort) {
            edges {
              node {
                ancestor {
                  title
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`);
